export const buildToolUrl = (rawUrl, toolLink, userEmail, isUserImpersonated) => {
  if (!rawUrl || typeof rawUrl !== "string") return "";

  let url;
  try {
    url = new URL(rawUrl);
  } catch {
    try {
      url = new URL(`https://${rawUrl}`);
    } catch {
      return "";
    }
  }

  const allowedKeys = [
    "externalUserId",
    "externalOrganizationId",
    "externalEmail",
    "externalOrganizationName",
  ];

  allowedKeys.forEach((key) => {
    const value = toolLink?.[key];
    if (value === undefined || value === null || value === "") return;
    url.searchParams.set(key, String(value));
  });

  if (userEmail) {
    url.searchParams.set("internalUserEmail", String(userEmail));
  }

  url.searchParams.set("isUserImpersonated", String(Boolean(isUserImpersonated)));

  return url.toString();
};

export const getOriginFromUrl = (rawUrl) => {
  try {
    return new URL(rawUrl).origin;
  } catch {
    return "";
  }
};
